import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-location';

const Redirect: React.FC = () => {
  const {
    data: { info },
  }: any = useMatch();
  const location = useLocation();
  useEffect(() => {
    location.history.replace(`/?messaging_service_key=${info.data.messaging_service_key}&task_sid=${info.data.task_sid}`);
  }, []);

  return <></>;
};

export default Redirect;
